import { CropStage } from '@/models/cropGuide'

import { get } from '../axios'

const getCropStages = (cropId: number, lang: string) =>
  get<CropStage[]>(`/khetibook/v1/crop-stages/${cropId}`, { lang })

export default getCropStages
